import { ViewHook } from "phoenix_live_view";
import { Tween, Easing } from "@tweenjs/tween.js";

class AnimatedRing extends ViewHook {
  private tween?: Tween;

  private duration?: number;
  private fill?: number;

  mounted() {
    if (!this.el.dataset.fill || !this.el.dataset.duration) {
      console.error("AnimatedRing: missing required data-attributes");
      return;
    }

    this.duration = Math.trunc(Number(this.el.dataset.duration));
    this.fill = Number(this.el.dataset.fill);

    const startOffset = Number(this.el.getAttribute("stroke-dashoffset") ?? "0");

    this.doAnimate({ fill: this.fill, startOffset });
  }

  updated() {
    const startOffset = this.fill!;
    this.fill = Number(this.el.dataset.fill!);

    if (startOffset === this.fill) {
      this.el.setAttribute("stroke-dashoffset", this.fill.toString());
    } else {
      this.doAnimate({ fill: this.fill, startOffset });
    }
  }

  destroyed() {
    this.tween?.stop();
    this.tween = undefined;
  }

  private doAnimate({ fill, startOffset }: { fill: number; startOffset: number }) {
    this.tween?.stop();

    const object = { offset: startOffset };

    this.tween = new Tween(object)
      .to({ offset: fill }, this.duration)
      .easing(Easing.Quadratic.Out)
      .onUpdate(() => {
        this.el.setAttribute("stroke-dashoffset", object.offset.toString());
      })
      .start();

    const animate = (time: number) => {
      this.tween?.update(time);
      requestAnimationFrame(animate);
    };

    requestAnimationFrame(animate);
  }
}

export default AnimatedRing;
